import type { AppDataInterface } from '~/types/AppData/AppDataInterface';
import PostPageOdessa from '~/templates/PostPageOdesa.json';
import PostPageFiji from '~/templates/PostPageFiji.json';
import PostPagePremium from '~/templates/PostPagePremium.json';

/**
 * Returns the name of the property given the property ID
 *
 * @param appData
 */
export const getTemplate = (appData: AppDataInterface) => {
  const template = appData.payloadToSSR.template;

  switch (template) {
    case 'PostPageOdessa':
      return PostPageOdessa;
    case 'PostPageFiji':
      return PostPageFiji;
    case 'PostPagePremium':
      return PostPagePremium;
  }

  return PostPageOdessa;
};
